import React from "react";
import BillPaymentOTP from "../views/bill-payment/bill-payment-otp";

export default function BillPaymentOTPUI(props) {

	return (
        <BillPaymentOTP {...props}/>
	)
}